<template>
    <path d="M15.7272 10.5291L5.24237 10.4408" stroke="#969696" stroke-linecap="square" stroke-linejoin="round" />
    <path d="M10.5148 5.24264L10.4549 15.7277" stroke="#969696" stroke-linecap="square" stroke-linejoin="round" />
</template>